import { useParams } from 'react-router-dom';

import { useGetDoc } from '@/api/queries/useGetDoc';
import { useGetMatterV2 } from '@/api/queries/useGetMatterV2';
import { Drawer } from '@/new/components/drawers/drawer';
import { Icon } from '@/new/components/icon';
import { PDFViewer } from '@/new/components/pdf-viewer';

interface DocumentDrawerProps {
  docId: string | null;
  isOpen: boolean;
  onClose: () => void;
}

export function DocumentDrawer({ docId, isOpen, onClose }: DocumentDrawerProps) {
  const { matterId } = useParams();
  if (!matterId) {
    return null;
  }
  // Get the id of the all documents case
  const { data: matter, isLoading: isLoadingMatter } = useGetMatterV2(matterId);
  const subsetId = matter?.allDocumentsCaseId ?? undefined;
  const { data: doc, isLoading: isLoadingDoc, error } = useGetDoc(subsetId ?? '', docId);

  return (
    <Drawer isOpen={isOpen} onClose={onClose} hideCloseButton={true}>
      <div className="flex h-full flex-col">
        {error ? (
          <div className="my-10 flex h-full w-full flex-col items-center justify-center text-red-600">
            <Icon className="lucide--warning text-2xl" />
            <div className="font-semibold">Sorry, there was a problem loading this document.</div>
            <div className="mt-2 text-xs text-gray-500">Please try again or contact support if the issue persists.</div>
          </div>
        ) : (
          <>
            {(isLoadingMatter || isLoadingDoc) && (
              <div className="my-20 flex h-full w-full items-center justify-center">
                <Icon className="lucide--loader-2 animate-spin duration-700" />
              </div>
            )}
            {doc && subsetId && docId && (
              <div className="flex-1 overflow-hidden">
                <PDFViewer
                  docId={docId}
                  highlights={[]}
                  hideFeatureButtons={true}
                  hideSnippingTool={true}
                  fileName={doc.file?.name}
                  closeViewer={onClose}
                />
              </div>
            )}
          </>
        )}
      </div>
    </Drawer>
  );
}
